const PREFIX = '#annotation-';

export function getAnnotationIdFromUrlHash(hash: string) {
  return typeof hash === 'string' && hash.startsWith(PREFIX)
    ? hash.slice(PREFIX.length)
    : null;
}

export default function annotationThreadHash(threadId: string) {
  return `${PREFIX}${threadId}`;
}
